module.exports = __webpack_public_path__ + "img/hands-asl-interpreting.89fc5334.svg";